var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor161(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M568 56.5H217V660.5H451.5V540.5H663V420.5H568V56.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M820 56.5H568V420.5H663V486H820V56.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1001 486H843.5H820V56.5H954.5H1068.5H1337.5V154.5H1322.5V535.5H1240.5V541.5H1001V486Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1505.5 535.5H1322.5V154.5H1337.5V104.5H1586.5H1816V152.5H1830V517.5H1646.5V535.5H1522.5H1505.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M1914.5 517.5H1830V152.5H1816L1816 75.5H2080.5V135V157V426H1975.5V490.5H1914.5V517.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M2346.5 75.5H2080.5V135V156.5V426H1975.5V536.5H2175V541.5H2445.5V352.5H2395.77V243H2346.5V75.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M1975.5 591V536.5H2175V541.5H2445.5V729.5H2395V840H2346V1024.5H2080.5H1815.5V923H1819V741.5V640.5V591H1898H1975.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1508 535.5H1646V674H1585V1024.64H1322.5V535.5H1492.5H1497.5H1508Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1240.5 541.5H1028V606H1001V673.5H1063V1024.63H1322.5V535.5H1240.5V541.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M217 935V660.5H451.5V540.5H663V608H745.5V594.5H817.5V923H833.5V1025H567.5H302.5V935H217Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor161);
export default __webpack_public_path__ + "static/media/select-floor-16_1.fec4f614.svg";
export { ForwardRef as ReactComponent };